import { AsyncDataProvider } from 'modules/data-providers';
import { useSelector } from 'modules/react-redux';
import { requestSelector } from 'pages/requestForm/selectors/pageSelectors';
import { FC, useCallback } from 'react';
import { useGetNetSuiteTaxAccounts } from 'shared/data/webApp/v2';

import { convertIntegrationCodeToDocumentType } from '../../helpers';
import { NetSuiteTaxAccountDataProviderProps } from './NetSuiteTaxAccountDataProvider.types';

export const NetSuiteTaxAccountDataProvider: FC<NetSuiteTaxAccountDataProviderProps> = (props) => {
    const { children, integrationCode } = props;

    const request = useSelector(requestSelector);
    const { id: requestId, companyId } = request;

    const { refetch } = useGetNetSuiteTaxAccounts(
        {
            path: { companyId, documentType: convertIntegrationCodeToDocumentType(integrationCode) },
        },
        { enabled: false }
    );

    const onLoad = useCallback(async () => {
        const data = (await refetch()).data;

        return (
            data?.reduce<Record<'id' | 'text', string>[]>((acc, value) => {
                if (value.id) {
                    acc.push({
                        id: value.id,
                        text: value.name || '',
                    });
                }

                return acc;
            }, []) || []
        );
    }, [refetch]);

    return (
        <AsyncDataProvider
            cacheStorageId={`requestOptions.netSuiteTaxAccounts.${requestId}`}
            pageSize={1000}
            onLoad={onLoad}
        >
            {children}
        </AsyncDataProvider>
    );
};

NetSuiteTaxAccountDataProvider.displayName = 'NetSuiteTaxAccountDataProvider';
